import type { FilterWrapperParams } from "ag-grid-community";
import type { CustomFilterDisplayProps } from "ag-grid-react";
import { useEffect, useRef } from "react";
import { HStack, Radio, RadioGroup } from "widgets";

export function CustomBooleanFilter({ model, onStateChange }: CustomFilterDisplayProps & FilterWrapperParams) {
  const firstFocusable = useRef<HTMLInputElement>(null);
  const selected = model?.filter == null ? "all" : String(model.filter);

  useEffect(() => {
    firstFocusable.current?.focus();
  }, []);

  const handleChange = (value: string) => {
    if (value === "all") {
      onStateChange({ model: null });
    } else {
      onStateChange({
        model: { filter: value, filterType: "boolean", type: "==" },
      });
    }
  };

  return (
    <div className="ag-simple-filter-body-wrapper">
      <RadioGroup defaultValue={selected} isRequired={true} key={selected} onChange={handleChange}>
        <HStack spacing={10} style={{ justifyContent: "space-around" }}>
          <Radio key="all" value="all">
            Both
          </Radio>
          <Radio key="true" value="true">
            Yes
          </Radio>
          <Radio key="false" value="false">
            No
          </Radio>
        </HStack>
      </RadioGroup>
    </div>
  );
}
